import React from 'react';
import styled from 'styled-components';

// Components
import EventsRecommended from '../../../_organisms/EventsRecommended';
import ErrorHandler from '../../../_molecules/ErrorHandler';
import SectionHeader from '../../../_molecules/SectionHeader';
import MyUpcomingEvents from '../../../_organisms/MyUpcomingEvents';
import MyEventHistory from '../../../_organisms/MyEventHistory';
import SavedEvents from '../../../_organisms/SavedEvents';
import { SectionWrapperInner, SectionWrapperOuter } from '@styled';

import useDocumentTitle from '@hooks/useDocumentTitle';
import TrackPageView from '@tracking/TrackPageView';

const HeaderContainer = styled.div`
    margin-bottom: 40px;
`;

const SectionContainer = styled.div`
    margin-bottom: 64px;
`;

const EventLandingPage = () => {
    const { documentTitle } = useDocumentTitle('My ICSC Events');

    return (
        <ErrorHandler>
            <TrackPageView>
                <SectionWrapperOuter>
                    <SectionWrapperInner className="fade-in-fast">
                        <SectionHeader
                            title={documentTitle}
                            tutorialLabel="How to use the Networking Platform"
                            tutorialUrl="https://view.ceros.com/icsc/icsc-networking-platfrom/p/1"
                        />
                        <HeaderContainer />

                        <SectionContainer>
                            <MyUpcomingEvents />
                        </SectionContainer>

                        <SectionContainer>
                            <EventsRecommended />
                        </SectionContainer>

                        <SectionContainer>
                            <SavedEvents />
                        </SectionContainer>

                        <MyEventHistory />
                    </SectionWrapperInner>
                </SectionWrapperOuter>
            </TrackPageView>
        </ErrorHandler>
    );
};

EventLandingPage.propTypes = {
    //
};

export default EventLandingPage;
